module.exports = __webpack_public_path__ + "files/12369512b60e0f4612d7809df69256f8.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-italic-webfont.eot
// module id = 404
// module chunks = 60